
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.255 14.406l1.795-.992a7.444 7.444 0 010-2.831L2.255 9.59a.479.479 0 01-.231-.564A9.953 9.953 0 014.328 5.21a.523.523 0 01.623-.092l1.795.992a8.041 8.041 0 012.56-1.416v-1.98c0-.226.165-.424.396-.472 1.546-.33 3.13-.315 4.6 0a.488.488 0 01.396.472v1.984a8.296 8.296 0 012.561 1.416l1.79-.992a.516.516 0 01.623.092 9.894 9.894 0 012.305 3.816.474.474 0 01-.232.564l-1.794.993a7.441 7.441 0 010 2.83l1.794.993c.206.113.299.347.232.565a9.954 9.954 0 01-2.305 3.815.523.523 0 01-.623.093l-1.794-.992a8.04 8.04 0 01-2.561 1.415v1.985a.488.488 0 01-.396.471c-1.546.331-3.13.315-4.6 0a.488.488 0 01-.396-.471v-1.985a8.294 8.294 0 01-2.56-1.415l-1.795.992a.517.517 0 01-.623-.093 9.894 9.894 0 01-2.304-3.815.49.49 0 01.235-.569zm9.747.819c1.858 0 3.37-1.448 3.37-3.227 0-1.778-1.512-3.226-3.37-3.226-1.857 0-3.37 1.448-3.37 3.226 0 1.779 1.513 3.227 3.37 3.227z","fill":"#282E3E"}})])
          )
        }
      }
    